import { OnlyHotelPackage, PackageHotel } from '@appTypes/api.types';

/**
 * Hotels "Search by periods" groups its rows by stay - docs#443 (Amiran 28.10.2026, "Every stay").
 * QA doc: docs features/website/search-forms.md R-SRF13 (J-SF14) and features/website/search-stay-length-2026-10-05.md R-SLR1.
 * A periods search answers every (check-in, check-out) stay of the chosen range; the results open ordered by stay and a stay header
 * (`hotels-result-stay-group-<yyyymmdd>-<yyyymmdd>`) starts each run of rows of the same stay. One stay on the page = no header.
 */
export const isPeriodsSearch = (model: { checkInDateTo?: unknown; nightsTo?: unknown } | null | undefined): boolean =>
  Boolean(model?.checkInDateTo) || Boolean(model?.nightsTo);

const day = (value: string | null | undefined): string => (value ?? '').slice(0, 10).replace(/-/g, '');

export const stayKey = (hotel: PackageHotel | null | undefined): string =>
  `${day(hotel?.checkInDate)}-${day(hotel?.checkOutDate)}`;

export const stayTestId = (hotel: PackageHotel | null | undefined): string =>
  'hotels-result-stay-group-' + stayKey(hotel);

/** The ids of the rows that open a new stay. Empty when every row of the page has the same stay (a dates search, or one stay left). */
export function stayGroupStarts(packages: OnlyHotelPackage[] | null | undefined): ReadonlySet<string> {
  const rows = packages ?? [];
  if (new Set(rows.map((row) => stayKey(row.hotel))).size < 2) return new Set();
  const starts = new Set<string>();
  rows.forEach((row, index) => {
    if (row.id && (index === 0 || stayKey(rows[index - 1].hotel) !== stayKey(row.hotel))) starts.add(row.id);
  });
  return starts;
}
